module.exports = __webpack_public_path__ + "img/success.74598625.svg";